import { useNavigation } from '@react-navigation/native';
import type { BottomTabNavigationProp } from '@react-navigation/bottom-tabs';
import type ApiPromotion from 'src/core/models/api/ApiPromotion';
import Constants from 'src/core/utils/Constants';
import { useGlobalStore } from 'src/domain/stores/useGlobalStore';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import type { BottomTabNavigation } from 'src/presentation/navigation/types/NavigationTypes';

// A promotion is managed in the DMP, so where its button leads is data instead of code. Both screens
// that show a promotion send the member off through here.
export const usePromotionActions = () => {
	const navigation = useNavigation<BottomTabNavigationProp<BottomTabNavigation>>();
	const { getGaOriginUrl } = useGlobalStore();
	const { confirmLeaving } = useLeaveAppStore();
	const { captureEvent } = useServicesStore();

	const openPromotion = (promotion: ApiPromotion) => {
		switch (promotion.button_action) {
			case 'none':
				return;

			case 'external': {
				const url = promotion.button_link;

				if (url === null || url.length === 0) {
					captureEvent({ message: 'Promotion without a link', extra: { promotionId: promotion.id } });

					return;
				}

				confirmLeaving({ url: getGaOriginUrl({ url }) });

				return;
			}

			case 'loyalty_screen':
				navigation.navigate(Constants.screenTabLoyalty, { screen: Constants.screenLoyalty });

				return;

			case 'inspiration_screen':
				navigation.navigate(Constants.screenTabInspiration, { screen: Constants.screenInspiration });

				return;

			case 'bath_card_screen':
				navigation.navigate(Constants.screenTabBathCard, { screen: Constants.screenBathCardsList });

				return;

			default:
				// An action added in the DMP that this app version does not know yet.
				captureEvent({
					message: 'Unknown promotion button action',
					extra: { promotionId: promotion.id, buttonAction: promotion.button_action },
				});
		}
	};

	return { openPromotion };
};

export default usePromotionActions;
